
import hoverintent from 'hoverintent';
export default class TeamMembers {
	constructor() {
		console.log('%c👍🏼 Team Members', 'color: yellow');           
		this.teamMembers = document.querySelectorAll('.team-members');
    }
    init() {
       
        this.teamMembers.forEach(module => {
            const tabPanes = module.querySelectorAll('.tab-pane');
            tabPanes.forEach(tabPane => {
                const singleImg = tabPane.querySelector('.team-members__img-wrapper img');
                const persons = tabPane.querySelectorAll('.team-members__person');
                const people = tabPane.querySelector('.team-members__people');

                persons.forEach(person => {
                    hoverintent(person, function() {
                        const activePerson = tabPane.querySelector('.team-members__img-wrapper img.active');
                        if(activePerson) {
                            // console.log('active acc', activePerson);
                            activePerson.classList.remove('active');
                            // activePerson.style.top = '0px';
                        
                            setTimeout(() => {
                                activePerson.style.top = '0px';
                            }, 350);
                        }

                        const panelImgSrc = this.dataset.memberImage;
                        if (!panelImgSrc) {
                            return;
                        }
                    
                        const peopleRect = people.getBoundingClientRect();
                        const personRect = this.getBoundingClientRect();
                        
                        console.log('personRect', personRect)
                        console.log('peopleRect', peopleRect)
                        setTimeout(() => {
                            singleImg.classList.add('active')
                            singleImg.setAttribute('src', panelImgSrc);
                            const top = personRect.top - peopleRect.top ;
                            singleImg.style.top = top + 'px';
                            // singleImg.style.top = 'auto';
                        }, 350);
                    }, function() {
                    
                    });
                });
            });
        });
    }
}